import { render, staticRenderFns } from "./NewAccount.vue?vue&type=template&id=61c04fe8&scoped=true&"
import script from "./NewAccount.vue?vue&type=script&lang=js&"
export * from "./NewAccount.vue?vue&type=script&lang=js&"
import style0 from "./NewAccount.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewAccount.vue?vue&type=style&index=1&id=61c04fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c04fe8",
  null
  
)

export default component.exports